var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a60c957c35dfb2490828bef76dca84f18bc3b72e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@playback-inc"]={id:"a60c957c35dfb2490828bef76dca84f18bc3b72e"};
      